import alertCircle from './alert-circle';
import alertTriangle from './alert-triangle';
import arrowUpRight from './arrow-up-right';
import box from './box';
import checkCircle from './check-circle';
import check from './check';
import chevronDown from './chevron-down';
import chevronRight from './chevron-right';
import chevronUp from './chevron-up';
import clock from './clock';
import disc from './disc';
import dollarSign from './dollar-sign';
import externalLink from './external-link';
import eyeOff from './eye-off';
import eye from './eye';
import home from './home';
import info from './info';
import loader from './loader';
import logOut from './log-out';
import logo from './logo';
import mapPin from './map-pin';
import menu from './menu';
import pauseCircle from './pause-circle';
import star from './star';
import tool from './tool';
import user from './user';
import xCircle from './x-circle';
import x from './x';
import zap from './zap';
import copy from './copy'
import navigation from './navigation'
import calender from './calender'

export default {
  alertCircle,
  alertTriangle,
  arrowUpRight,
  box,
  checkCircle,
  check,
  chevronDown,
  chevronRight,
  chevronUp,
  clock,
  disc,
  dollarSign,
  externalLink,
  eyeOff,
  eye,
  home,
  info,
  loader,
  logOut,
  logo,
  mapPin,
  menu,
  pauseCircle,
  star,
  tool,
  user,
  xCircle,
  x,
  zap,
  copy,
  navigation,
  calender,
};

// To create new tsx component from a svg use:
// npx @svgr/cli --template <path to template file> --ext .ts <svg file name>
// e.g: npx @svgr/cli --template ./template.js --ext .ts logo.svg
